export enum SupportedLanguage {
  EN = "en",
  DE = "de",
}
